import { BuyCloudSiteSetupPageTemplate } from "../../../../templates/buy/cloud/site-setup/src/buy-cloud-site-setup-page.template";

export const BuyCloudSiteSetupPage = () => <BuyCloudSiteSetupPageTemplate />;
